<div class="com-component">
  <dsy-card class="card-container" [noPadding]="true">
    <div class="card-content">
      <dr-flex-home-ui-widget-header [title]="'FLEX_HOME.ERP_WIDGET.TITLE' | translate"></dr-flex-home-ui-widget-header>
      <div class="erp-widget">
        @if (isLoading()) {
          <div class="loading-spinner">
            <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
          </div>
        } @else if (errorMessage()) {
          <div class="error">{{ errorMessage() }}</div>
        } @else if (!registrations().length) {
          <div class="empty">
            <dr-flex-home-ui-empty-state [showPermissionStatus]="true" [title]="'FLEX_HOME.COMMON.NO_DATA'"></dr-flex-home-ui-empty-state>
          </div>
        } @else {
          <div class="erp-widget__header">
            <div class="erp-widget__header-item">
              <div class="drop-down">
                <dsy-input-dropdown
                  [entries]="programsDropDownListSingle()"
                  [exclusiveSelection]="true"
                  [closesOnSelection]="true"
                  [label]="'FLEX_HOME.ERP_WIDGET.PROGRAM' | translate"
                  density="wide"
                ></dsy-input-dropdown>
              </div>
            </div>

            <div class="erp-widget__header-item">
              <div class="drop-down">
                <dsy-input-dropdown
                  [entries]="sitesDropDownListSingle()"
                  [exclusiveSelection]="true"
                  [closesOnSelection]="true"
                  [label]="'FLEX_HOME.ERP_WIDGET.SITE' | translate"
                  density="wide"
                ></dsy-input-dropdown>
              </div>
            </div>
          </div>

          @if (hasEnergyReductionPlanContent()) {
            <div class="erp-widget__content-text" [innerHTML]="energyReductionPlanContent()"></div>
          } @else {
            <div class="empty">
              <dr-flex-home-ui-empty-state [showPermissionStatus]="true" [title]="'FLEX_HOME.ERP_WIDGET.NO_ERP_FOR_SITE' | translate"></dr-flex-home-ui-empty-state>
            </div>
          }
        }
      </div>
    </div>
  </dsy-card>
</div>
